import { render, staticRenderFns } from "./JordanPurchase.vue?vue&type=template&id=83c60758&scoped=true&"
import script from "./JordanPurchase.vue?vue&type=script&lang=js&"
export * from "./JordanPurchase.vue?vue&type=script&lang=js&"
import style0 from "./JordanPurchase.vue?vue&type=style&index=0&id=83c60758&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c60758",
  null
  
)

export default component.exports